import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "./pages/Home/Home";
import Layout from "./components/Layout/Layout";
import Projects from "./pages/Projects/Projects";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        { path: "/projects", element: <Projects /> },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default App;
